import { useSelector } from 'react-redux'

import buyerLogic from '../assets/buyer-logic.json'
import sellerLogic from '../assets/seller-logic.json'
import lines from '../assets/tekstit.json'

export const useLogic = () => {
    const role = useSelector(state => state.role)

    const logicSheet = () => {
        if (role === 'seller') {
            return sellerLogic
        }
        return buyerLogic
    }

    const getSet = (act, set) => {
        const sheet = logicSheet()
        const currentAct = sheet.find(listAct => listAct.act === act)

        if (!currentAct?.sets) {
            return null
        }

        return currentAct.sets.find(listSet => listSet.setNo === set)
    }

    const getPlayerOptions = (options) => {
        const populated = options.map(element => {
            element.text = getLine(element.hint)
            return element
        })

        return populated
    }

    const randomResponse = (options) => {
        const rand = Math.floor(Math.random() * options.length)
        const calculated = options[rand]
        return {
            code: calculated,
            line: getLine(calculated)
        }
    }

    const getOpponentResponse = (options) => {
        const rand = Math.floor(Math.random() * options.length)
        const calculated = options[rand]

        return {
            code: calculated,
            speaker: calculated[0] === 'A' ? 'seller' : 'buyer',
            text: getLine(calculated)
        }
    }

    //private
    const getLine = (code) => {
        if (code.winner || code.winner === false) {
            code = code.code
        }

        const foundLine = lines.find(line => line.code === code)
        return foundLine.text
    }

    return {
        logicSheet,
        getSet,
        getPlayerOptions,
        randomResponse,
        getOpponentResponse
    }
}